import React from 'react';
import Header from '../components/CommonComponents/Header';
import CrossProjectTasksComponent from '../components/CrossProjectTasks';
import { useSelector } from 'react-redux';
const CrossProjectTasks = () => {
    const { selectedProject } = useSelector(state => state?.projectData);
    return (
        <>
            <Header hideProjectItems={selectedProject ? false : true} />
            <div>
                <CrossProjectTasksComponent />
                {/* Empty screen - can be customized later */}
            </div>
        </>
    );
};

export default CrossProjectTasks;
